import { render, staticRenderFns } from "./InventBomRoute.vue?vue&type=template&id=6c966ace"
import script from "./InventBomRoute.vue?vue&type=script&lang=js"
export * from "./InventBomRoute.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports